/*eslint no-useless-escape: 0*/
import { useState } from 'react';

type StarSize = 'md' | 'lg';

interface IReviewStarsSelect {
  onClick?: () => void;
  ratingSelected: null | number;
  setRatingSelected: (rating: number) => void;
  size?: StarSize;
}

const ReviewStarsSelect: React.FC<IReviewStarsSelect> = ({
  onClick,
  ratingSelected,
  setRatingSelected,
  size = 'md',
}) => {
  const [hoveredStars, setHoveredStars] = useState<null | number>(null);
  const allStars = [...new Array(5).keys()];

  const handleOnClick = (index: number) => {
    if (ratingSelected === index) {
      return;
    }

    setRatingSelected(index);
  };

  const isOn = (index: number): string => {
    if (ratingSelected !== null && index <= ratingSelected) {
      return 'on';
    } else if (hoveredStars === null) {
      return 'off';
    } else if (index <= hoveredStars) {
      return 'on';
    }

    return 'off';
  };

  return (
    <>
      {allStars.map((index) => {
        return (
          <button
            key={index}
            type="button"
            className={`star tw-lf-button-clear ${isOn(index)}`}
            onClick={() => {
              handleOnClick(index);
              onClick && onClick();
            }}
            onMouseEnter={() => setHoveredStars(index)}
            onMouseLeave={() => setHoveredStars(null)}
            aria-label={`${index + 1}/${allStars.length}`}
          />
        );
      })}
      <style jsx>{`
        @font-face {
          font-family: 'Star';
          src: url('data:application/x-font-woff;charset=utf-8;base64,d09GRgABAAAAAAScAA0AAAAABrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAEgAAAABoAAAAcbyQ+3kdERUYAAARgAAAAHgAAACAAMwAGT1MvMgAAAZgAAABGAAAAVi+vS9xjbWFwAAAB8AAAAEAAAAFKwBMjvmdhc3AAAARYAAAACAAAAAj//wADZ2x5ZgAAAkAAAAEJAAABdH33LXtoZWFkAAABMAAAAC0AAAA2BroQKWhoZWEAAAFgAAAAHAAAACQD5QHQaG10eAAAAeAAAAAPAAAAFAYAAABsb2NhAAACMAAAAA4AAAAOAO4AeG1heHAAAAF8AAAAHAAAACAASgAvbmFtZQAAA0wAAADeAAABkorWfVZwb3N0AAAELAAAACkAAABEp3ubLXgBY2BkYADhPPP4OfH8Nl8ZuJkYQODS2fRrCPr/aSYGxq1ALgcDWBoAO60LkwAAAHgBY2BkYGDc+v80gx4TAwgASaAICmABAFB+Arl4AWNgZGBgYGPQYWBiAAIwyQgWc2AAAwAHVQB6eAFjYGRiYJzAwMrAwejDmMbAwOAOpb8ySDK0MDAwMbByMsCBAAMCBKS5pjA4PGB4wMR44P8BBj3GrQymQGFGkBwAjtgK/gAAeAFjYoAAEA1jAwAAZAAHAHgB3crBCcAwDEPRZydkih567CDdf4ZskmLwFBV8xBfCaC4BXkOUmx4sU0h2ngNb9V0vQCxaRKIAevT7fGWuBrEAAAAAAAAAAAA0AHgAugAAeAF9z79Kw1AUx/FzTm7un6QmJtwmQ5Bg1abgEGr/BAqlU6Gju+Cgg1MkQ/sA7Vj7BOnmO/gUvo2Lo14NqIO6/IazfD8HEODtmQCfoANwNsyp2/GJt3WKQrd1NLiYYWx2PBqOsmJMEOznPOTzfSCrhAtbbLdmeFLJV9eKd63WLrZcIcuaEVdssWCKM6pLCfTVOYbz/0pNSMSZKLIZpvh78sAUH6PlMrreTCabP9r+Z/puPZ2ur/RqpQHgh+MIegCnXeM4MRAPjYN//5tj4ZtTjkFqEdmeMShlEJ7tVAly2TAkx6R68Fl4E/aVvn8JqHFQ4JS1434gXKcuL31dDhzs3YbsEOAd/IU88gAAAHgBfY4xTgMxEEVfkk0AgRCioKFxQYd2ZRtpixxgRU2RfhU5q5VWseQ4JdfgAJyBlmNwAM7ABRhZQ0ORwp7nr+eZAa54YwYg9zm3ynPOeFRe8MCrciXOh/KSS76UV5L/iDmrLiS5AeU519wrL3jmSbkS5115yR2fyivJv9kx0ZMZ2RLZw27q87iNQi8EBo5FSPIMw3HqBboi5lKTGAGDp8FKXWP+t9TU01Lj5His1Ba6uM9dTEMwvrFmbf5GC/q2drW3ruXUhhsCiQOjznFlCzYhHUZp4xp76vsvQh89CQAAeAFjYGJABowM6IANLMrEyMTIzMjCXpyRWJBqZshWXJJYBKOMAFHFBucAAAAAAAAB//8AAngBY2BkYGDgA2IJBhBgAvKZGViBJAuYxwAABJsAOgAAeAFjYGBgZACCk535hiD60tn0azAaAEqpB6wAAA==')
            format('woff');
          font-weight: normal;
          font-style: normal;
        }

        .star {
          font-family: 'Star';
          display: inline;
          text-decoration: none;
          padding: 0 var(--space-2) 0 0;
          margin: 0;
          font-weight: bold;
          opacity: 1;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          color: #ffd826;
          font-size: ${size === 'lg' ? '28px' : 'initial'};
        }

        .star:last-of-type {
          padding: 0;
        }

        .star.on:before {
          content: '\e000';
        }

        .star.off:before {
          content: '\e001';
        }
      `}</style>
    </>
  );
};

export default ReviewStarsSelect;
